<style lang="scss">
@import 'resources/sass/v1/abstracts/_variables';

.article-card {
    background-color: $white;
    position: relative;

    h2 {
        padding-right: 16px;
    }

    &.locked {
        box-shadow: none;
        position: relative;

        a {
            z-index: 2;
        }

        h2,
        p,
        .tags,
        .read-more {
            opacity: 0.5;
        }

        p {
            opacity: 0.3;
            color: transparent;
            text-shadow: 0 0 5px rgba(18, 18, 18, 0.35);
            -webkit-user-select: none; /* Safari */
            -moz-user-select: none; /* Firefox */
            -ms-user-select: none; /* IE10+/Edge */
            user-select: none; /* Standard */
        }

        &:after {
            content: url('/svg/article-locked.svg');
            width: 65px;
            height: 77px;
            position: absolute;
            right: 0;
            top: 0;
        }
    }
}
</style>

<template>
    <div class="article-card border border-gray w-full" :class="{ locked: articleItem.acf.locked }">
        <a class="inline-block w-full group h-full relative p-5 lg:p-8" :href="articleUrl">
            <div class="article-content">
                <h2 class="text-18 font-bold text-primary mb-6" v-html="articleItem.title.rendered"></h2>
                <div class="tags pointer-events-none mb-4">
                    <span v-for="category in categories" :key="`${articleItem.id}.${category.id}`" class="tag mb-2">{{ category.name }}</span>
                </div>
                <p class="mb-6 text-primary text-12" v-html="articleItem.acf.intro"></p>
                <span class="text-link text-link-primary"
                    >{{ translations.read_more }} <svg-vue icon="arrow-right" class="text-primary ml-[.625rem] h-[.625rem] w-auto transition-transform group-hover:translate-x-1"></svg-vue>
                </span>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    data() {
        return {
            articleUrl: route(`${this.locale}.article`, [this.articleItem.slug]),
        };
    },

    props: {
        articleItem: {
            type: Object,
            required: true,
        },
        categories: {
            type: Array,
            required: true,
        },
        locale: {
            type: String,
            required: true,
        },
        translations: {
            type: Object,
            required: true,
        },
    },
};
</script>
